import api from '../utils/api';

export const getJWTToken = async (query: string): Promise<any> => {
    return await api.get(`/auth/google/callback${query}`)
        .then((response) => response.data);
};